import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const WHATSAPP_MESSAGE = "Hi HOPE INTERNATIONAL, I'm interested in your export products. Please share quotation and product details.";
const WHATSAPP_LINK = `https://wa.me/916267592923?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function ApplicationsPage() {
  const applications = [
    {
      title: "Nutraceutical Capsules & Tablets",
      description: "Our powders are suitable for brands and manufacturers preparing capsules, tablets, and dietary supplement formulations."
    },
    {
      title: "Herbal Tea & Infusions",
      description: "Ideal for herbal tea blends, functional tea mixes, and traditional wellness preparations."
    },
    {
      title: "Smoothies & Functional Beverages",
      description: "Use our powders in wellness drinks, smoothie blends, and functional beverage applications."
    },
    {
      title: "Food & Seasoning Blends",
      description: "Suitable for food-grade use in spice blends, seasoning mixes, and functional food products."
    },
    {
      title: "Ayurveda & Traditional Formulations",
      description: "Traditionally used in Ayurveda-based wellness formulations and daily health routines."
    },
    {
      title: "Private Label Retail Packs",
      description: "We support retail-ready packaging for brands and distributors with custom labeling options."
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Applications</h1>
        <div className="title-underline"></div>
      </div>
      
      <div className="page-intro">
        <p>HOPE INTERNATIONAL supplies export-grade herbal and natural powders suitable for multiple industries. Our products are widely used in nutraceutical, food, wellness, and private label applications.</p>
      </div>

      <div className="applications-grid">
        {applications.map((app, index) => (
          <div key={index} className="application-card">
            <div className="app-number">{index + 1}</div>
            <h3>{app.title}</h3>
            <p>{app.description}</p>
          </div>
        ))}
      </div>

      <div className="page-cta-section">
        <h3>Looking for bulk pricing or private label packing?</h3>
        <div className="cta-buttons">
          <Link to="/request-quote" className="btn-primary">Request a Quote</Link>
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
            WhatsApp Now
          </a>
        </div>
      </div>
    </div>
  );
}

export default ApplicationsPage;
